import { useModalStore } from '@/stores/useModalStore';
import { Button } from '@/components/ui';
import styles from './ConfirmModal.module.css';

interface ConfirmModalProps {
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onCancel?: () => void;
    handleClose?: () => void;
}

export function ConfirmModal({
    title,
    message,
    confirmLabel = 'Aceptar',
    cancelLabel = 'Cancelar',
    onConfirm,
    onCancel,
}: ConfirmModalProps) {
    const { closeModal } = useModalStore();

    const handleConfirm = () => {
        closeModal();
        onConfirm();
    };

    const handleCancel = () => {
        closeModal();
        onCancel?.();
    };

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.message}>{message}</p>
            <div className={styles.actions}>
                <Button variant="secondary" size="sm" onClick={handleCancel}>
                    {cancelLabel}
                </Button>
                <Button variant="primary" size="sm" onClick={handleConfirm}>
                    {confirmLabel}
                </Button>
            </div>
        </div>
    );
}
